export default __webpack_public_path__ + "static/media/mp-20.451464ce.jpg";